import { TextSize } from 'components'
import ArrowIcon from 'assets/menu-icons/arrow.svg?react'
import styled, { css } from 'styled-components'
import { Weight } from '../../../../components/typography/text/index'

/**
 * Wrapper around arrow and tooltip
 */
export const Container = styled.div<{ hide: boolean }>`
  opacity: ${({ hide }) => (hide ? 0 : 1)};
  transition: opacity 500ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
`

export const TriangleContainer = styled.div<{ left: string; top: string }>`
  position: absolute;
  left: ${({ left }) => left};
  top: ${({ top }) => top};
  z-index: 900;
`
/**
 * Styling for the tooltip wrapper
 */
export const TooltipWrapper = styled.div`
  box-sizing: border-box;
  gap: 15px;
  width: 290px;
  min-height: 155px;
  border: 3px solid ${({ theme }) => theme.coralBlueToWhite};
  background: ${({ theme }) => theme.whiteToBlack};
  border-radius: 10px;
  color: ${({ theme }) => theme.coralBlueToWhite};
  padding: 20px;
  display: flex;
  flex-direction: column;
  letter-spacing: 0em;
`

export const ContentWrapper = styled.div`
  line-height: 15.6px;
  letter-spacing: 0em;
  text-align: left;
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
`

/**
 * Styling for the tooltip title
 */
export const Title = styled.div`
  font-size: ${TextSize.four};
  font-weight: ${Weight.Bold};
  line-height: 17px;
  color: ${({ theme }) => theme.coralBlueToWhite};
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const CloseButton = styled.div`
  cursor: pointer;
  & > svg > path {
    fill: ${({ theme }) => theme.primaryFontColor};
    stroke: ${({ theme }) => theme.primaryFontColor};
  }
`

export const StyledArrow = styled(ArrowIcon)`
  & > path {
    fill: ${({ theme }) => theme.coralBlueToWhite} !important;
    stroke: ${({ theme }) => theme.coralBlueToWhite};
  }
`
export const LeftFacingArrow = styled(StyledArrow)`
  transform: rotate(180deg);
`
export const ArrowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-top: 2px;
`
export const ArrowSpan = styled.span``

export const ControlButtons = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: ${TextSize.four};
  font-weight: ${Weight.Medium};
  line-height: 20px;
  letter-spacing: 0em;
  text-align: right;
  color: ${({ theme }) => theme.coralBlueToWhite};
  ${({ isDisabled }) =>
    !isDisabled &&
    css`
      cursor: pointer;
    `}
  ${({ isDisabled }) =>
    isDisabled === true &&
    css`
      opacity: 0.5;
    `}
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
/**
 * Styling for the buttons (back forward )
 */
export const Buttonwrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: ${TextSize.four};
  font-weight: ${Weight.Bold};
  line-height: 20px;
  :hover {
    cursor: pointer;
  }
`
